import axiosInstance from '@/axios/index';
export default {
  getNotifyList(state, data) {
    const vm = data.vm;
    if(data.page) state.state.notification.page = data.page;
    const page = state.state.notification.page;
    return axiosInstance("put", '/apiserver/notify/list', {
      aid: vm.loginProfile.auth_id,
      size: 20,
      page: 1,
    })
    .then(({ count, results }) => {
      page === 1
        ? state.state.notification.list = results
        : results.map((x) => state.state.notification.list.push(x));
      state.state.notification.count = count;
      state.state.notification.page += 1;
      return results.filter(item => item.remind === 'yes').length;
    })
    .catch((err) => {
      if (err.response.data === 'no permission') {
        localStorage.removeItem('cc-cms');
        vm.$router.push({ name: 'Login' });
      }
    })
  },

};
